enum ProvisionType {
  CREATE_NEW = '[PROVISION] NEW',
  CREATE_NEW__SUCCESS = '[PROVISION] NEW__SUCCESS',
  TEAR_DOWN = '[PROVISION] TEAR_DOWN',
  HANDLE_SUCCESS = '[PROVISION] SUCCESS',
  HANDLE_FAILURE = '[PROVISION] FAILURE',
}

export default ProvisionType;
